// demo
// export const PKEY = "pk_test_51KYApgIVZzCPjJy1AcGTgGIdsl1PIaFUD6ESfIHaHSUhkdOWMnxB2S1loW23d8APfcgrJ44V7VobrS8sw8L0ijrI00VCtlDoqr";
// live
export const PKEY = "pk_live_51KYVJBJPlsQvriwzYdzyqJescOd0X5aMZuUGZWY91NC22qVNvXwHolVtlOPlh1w8M8Nysmb6Z0Dvg5yne74yjhxA00OsdWV6IR";